import { useState } from 'react';
import { faqData } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于韩国旅行，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}